module.exports = __webpack_public_path__ + "img/enamad_1.b31e650d.png";